const BACKGROUND_SOUND = new Audio(
  new URL('~/public/assets/audios/backgroundSound.mp3', import.meta.url).href
)

BACKGROUND_SOUND.loop = true

export default BACKGROUND_SOUND
